import { useEffect, useState } from "react";

import { Toaster } from "@/components/ui/sonner";

import { useLanguage } from "@/contexts/language";

const APP_TOASTER_OWNER_KEY = "__appToasterOwner";

type AppToasterWindow = Window & {
  [APP_TOASTER_OWNER_KEY]?: string;
};

export function AppToaster() {
  const { dir } = useLanguage();
  const [ownerId] = useState(
    () => `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`,
  );
  const [isOwner, setIsOwner] = useState(false);

  useEffect(() => {
    const appWindow = window as AppToasterWindow;

    if (!appWindow[APP_TOASTER_OWNER_KEY]) {
      appWindow[APP_TOASTER_OWNER_KEY] = ownerId;
    }

    setIsOwner(appWindow[APP_TOASTER_OWNER_KEY] === ownerId);

    return () => {
      if (appWindow[APP_TOASTER_OWNER_KEY] === ownerId) {
        delete appWindow[APP_TOASTER_OWNER_KEY];
      }
    };
  }, [ownerId]);

  if (!isOwner) {
    return null;
  }

  return (
    <Toaster
      dir={dir}
      position="top-center"
      richColors
      closeButton
      duration={2500}
      style={{ fontSize: "1.05rem" }}
      toastOptions={{
        style: {
          padding: "16px 20px",
          fontSize: "1.05rem",
          fontWeight: 600,
        },
      }}
    />
  );
}
